import { render, staticRenderFns } from "./orderPayInfo.vue?vue&type=template&id=c52379c0&scoped=true&"
import script from "./orderPayInfo.vue?vue&type=script&lang=js&"
export * from "./orderPayInfo.vue?vue&type=script&lang=js&"
import style0 from "./orderPayInfo.vue?vue&type=style&index=0&id=c52379c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52379c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c52379c0')) {
      api.createRecord('c52379c0', component.options)
    } else {
      api.reload('c52379c0', component.options)
    }
    module.hot.accept("./orderPayInfo.vue?vue&type=template&id=c52379c0&scoped=true&", function () {
      api.rerender('c52379c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/module/orderPayInfo.vue"
export default component.exports